var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderCartUnpopulated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75781 6H21.1092C21.2191 6 21.3276 6.02413 21.4271 6.07068C21.5266 6.11724 21.6146 6.18508 21.685 6.26941C21.7554 6.35374 21.8064 6.45251 21.8344 6.55872C21.8625 6.66494 21.8668 6.77601 21.8472 6.88409L20.2117 15.8841C20.1803 16.0569 20.0893 16.2132 19.9544 16.3258C19.8196 16.4383 19.6495 16.5 19.4738 16.5H7.30018C7.1246 16.5 6.95459 16.4384 6.81977 16.3259C6.68494 16.2135 6.59384 16.0573 6.56234 15.8845L4.18823 2.86545C4.15673 2.69273 4.06563 2.53652 3.9308 2.42406C3.79598 2.3116 3.62597 2.25 3.45039 2.25H1.75781",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75781 21.75C8.58624 21.75 9.25781 21.0784 9.25781 20.25C9.25781 19.4216 8.58624 18.75 7.75781 18.75C6.92939 18.75 6.25781 19.4216 6.25781 20.25C6.25781 21.0784 6.92939 21.75 7.75781 21.75Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0078 21.75C19.8362 21.75 20.5078 21.0784 20.5078 20.25C20.5078 19.4216 19.8362 18.75 19.0078 18.75C18.1794 18.75 17.5078 19.4216 17.5078 20.25C17.5078 21.0784 18.1794 21.75 19.0078 21.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderCartUnpopulated);
export default __webpack_public_path__ + "static/media/headerCartUnpopulated.53e4a221aeea9458a84f8488035b288d.svg";
export { ForwardRef as ReactComponent };